import React from 'react';
import Spinner from './spinner';

function ShowSpinner(props) {
  const { showSpinner } = props;
  return <React.Fragment>{showSpinner && <Spinner />}</React.Fragment>;
}

export default ShowSpinner;
